<template>
    <div class="coupon-used" v-infinite-scroll="loadMore" infinite-scroll-disabled="canNotLoadMore" infinite-scroll-distance="10" infinite-scroll-immediate-check="false" style="-webkit-user-drag: none;">
        <div class="empty" v-if="! usedCoupons.length">
            <img src="@/assets/img/empty-ticket.png">
            <div class="title">
                目前沒有優惠卷
            </div>
        </div>
        <div class="list" v-else>
            <coupon-item v-for="coupon in usedCoupons" :key="coupon.id" :coupon="coupon"/>
        </div>
    </div>
</template>

<script>
    import CouponItem from "./CouponItem";
    import {mapActions, mapGetters} from "vuex";

    export default {
        name: "CouponUsed",
        components: {
            'coupon-item': CouponItem,
        },
        data() {
            return {
                loading: false,
            }
        },
        computed: {
            canNotLoadMore() {
                return !(this.usedCouponsMeta.total && this.usedCouponsMeta.current_page < this.usedCouponsMeta.last_page && !this.loading);
            },
            ...mapGetters(['usedCoupons', 'usedCouponsMeta'])
        },
        methods: {
            loadMore() {
                this.loading = true;
                this.loadMoreUsedCoupons().finally(() => {
                    this.loading = false;
                })
            },
            ...mapActions(['getUsedCoupons', 'loadMoreUsedCoupons'])
        },
        created() {
            this.loading = true;
            this.getUsedCoupons().finally(() => {
                this.loading = false;
            });
        }
    }
</script>

<style lang="scss" scoped>
    .coupon-used {
        padding: 15px;
    }

    .empty {
        margin-top: 150px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        img {
            height: 50px;
            width: 50px;
        }

        .title {
            margin-top: 30px;
            color: #4A4A4A;
            font-size: 20px;
            line-height: 28px;
            text-align: center;
        }

        .button {
            margin-top: 34px;
            height: 25px;
            border-radius: 13px;
            background-color: #339933;
            color: #FFFFFF;
            font-size: 12px;
            line-height: 17px;
            display: flex;
            justify-content: center;
            align-items: center;
            width: 100px;
        }
    }
</style>